import { Api } from '@/services/Api'

export default {
    getUniversityDiscountManagements(body = { keyword: '' }) {
        return Api().post('/UniversityDiscountManagement/GetProvideLaptopByCriteria', body)
    },
    getUniversityDiscountManagement(id) {
        return Api().get(`/UniversityDiscountManagement/${id}`);
    },
    saveUniversityDiscountManagement(body) {
        return Api().post(`/UniversityDiscountManagement`, body);
    },
    deleteUniversityDiscountManagement(universityDiscountManagement) {
        return Api().post(`/UniversityDiscountManagement/DeleteUniversityDiscountManagement`, universityDiscountManagement);
    },
    postUniversityDiscountManagement(universityDiscountManagement) {
        return Api().post(`/UniversityDiscountManagement/PostGroup`, universityDiscountManagement);
    },
    startWF(body) {
        return Api().post(`/UniversityDiscountManagement/StartWF`, body);
    }
}